import factory from "./factory";

const authRequest = factory({
  baseURL: `${process.env.REACT_APP_API_AUTH_URL}`,
});

export default authRequest;
